__turbopack_context__.v({
  "bar": "design-variations-bar-module__1uqn9q__bar",
  "current": "design-variations-bar-module__1uqn9q__current",
  "label": "design-variations-bar-module__1uqn9q__label",
  "left": "design-variations-bar-module__1uqn9q__left",
  "link": "design-variations-bar-module__1uqn9q__link",
  "links": "design-variations-bar-module__1uqn9q__links",
  "themeToggle": "design-variations-bar-module__1uqn9q__themeToggle",
});
